<router-outlet *ngIf="addressesLoaded"></router-outlet><toaster-container [toasterconfig]="toasterConfiguration" dir="rtl"></toaster-container>